module.exports = __webpack_public_path__ + "img/IMG_8473_P_L_Black.dc5e502e.jpg";